import React, { Component } from "react";
import { NavItem, Badge } from "reactstrap";
import { NavLink } from "react-router-dom";
import PerfectScrollbar from "react-perfect-scrollbar";
import classnames from "classnames";

import ApplicationMenu from "../../../components/common/ApplicationMenu";
import IntlMessages from "../../../helpers/IntlMessages";

class WarehouseImportApplicationMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      priceRange: [
        { label: "price.under-1m", value: 1000000 },
        { label: "price.1m-to-10m", value: 5000000 },
        { label: "price.over-10m", value: 10000000 },
      ],
      quantityRange: [
        { label: "quantity.under-10", value: 10 },
        { label: "quantity.10-to-50", value: 50 },
        { label: "quantity.over-50", value: 51 },
      ],
    };
  }

  render() {
    const { priceRange, quantityRange } = this.state;

    const { data, filter, filterData } = this.props;
    // console.log('data :', data);

    // const personAdd = data.map((person) => person.user.fullname);
    // const personUnique = [...new Set(personAdd)];

    const status = data.map((u) => u.status);
    const statusUnique = [...new Set(status)];
    // console.log('statusUnique: ', statusUnique);

    return (
      <ApplicationMenu>
        <PerfectScrollbar
          options={{ suppressScrollX: true, wheelPropagation: false }}
        >
          <div className="p-4">
            <NavItem
              className={classnames(
                {
                  active: !filter,
                },
                "mb-5",
              )}
            >
              <NavLink
                location={{}}
                to="#"
                onClick={(e) => filterData("", "")}
                className="d-flex justify-content-between align-items-center"
              >
                <div className="d-flex align-items-center">
                  <i className="simple-icon-check mr-10" />
                  <span>
                    <IntlMessages id="general.all" />
                  </span>
                </div>
                <span className="float-right">{data.length}</span>
              </NavLink>
            </NavItem>
            <p className="text-muted text-small">
              <IntlMessages id="menu.warehouse.status" />
            </p>
            <ul className="list-unstyled mb-5">
              {statusUnique.map((c, index) => {
                return (
                  <NavItem key={index}>
                    <div
                      onClick={(e) => filterData("status", c)}
                      className="d-flex justify-content-between align-items-center"
                    >
                      <div className="custom-control custom-radio">
                        <input
                          type="radio"
                          name="status"
                          className="custom-control-input"
                          defaultChecked={
                            filter &&
                            filter.column === "status" &&
                            filter.value === c
                          }
                        />
                        <label className="custom-control-label">{c}</label>
                      </div>
                      <span className="float-right">
                        {data.filter((d) => d.status === c).length}
                      </span>
                    </div>
                  </NavItem>
                );
              })}
            </ul>
            <p className="text-muted text-small">
              <IntlMessages id="menu.finance.price-range" />
            </p>
            <ul className="list-unstyled mb-5">
              {priceRange.map((c, index) => {
                return (
                  <NavItem key={index}>
                    <div onClick={(e) => filterData("price", c.value)}>
                      <div className="custom-control custom-radio">
                        <input
                          type="radio"
                          name="price"
                          className="custom-control-input"
                          defaultChecked={
                            filter &&
                            filter.column === "price" &&
                            filter.value === c.value
                          }
                        />
                        <label className="custom-control-label">
                          <IntlMessages id={c.label} />
                        </label>
                      </div>
                    </div>
                  </NavItem>
                );
              })}
            </ul>
            <p className="text-muted text-small">
              <IntlMessages id="menu.warehouse.quantity-range" />
            </p>
            <ul className="list-unstyled mb-5">
              {quantityRange.map((c, index) => {
                return (
                  <NavItem key={index}>
                    <div onClick={(e) => filterData("quantity", c.value)}>
                      <div className="custom-control custom-radio">
                        <input
                          type="radio"
                          name="quantity"
                          className="custom-control-input"
                          defaultChecked={
                            filter &&
                            filter.column === "quantity" &&
                            filter.value === c.value
                          }
                        />
                        <label className="custom-control-label">
                          <IntlMessages id={c.label} />
                        </label>
                      </div>
                    </div>
                  </NavItem>
                );
              })}
            </ul>
            <p className="text-muted text-small">
              <IntlMessages id="menu.finance.creator" />
            </p>
            <ul className="list-unstyled mb-5">
              {/* {personUnique.map((c, index) => {
                                return (
                                    <NavItem key={index}>
                                        <div
                                            onClick={(e) =>
                                                filterData('fullname', c)
                                            }
                                        >
                                            <div className='custom-control custom-radio'>
                                                <input
                                                    type='radio'
                                                    name='fullname'
                                                    className='custom-control-input'
                                                    defaultChecked={
                                                        filter &&
                                                        filter.column ===
                                                            'fullname' &&
                                                        filter.value === c
                                                    }
                                                />
                                                <label className='custom-control-label'>
                                                    {c}
                                                </label>
                                            </div>
                                        </div>
                                    </NavItem>
                                );
                            })} */}
            </ul>
          </div>
        </PerfectScrollbar>
      </ApplicationMenu>
    );
  }
}

export default WarehouseImportApplicationMenu;
